import React, { useState } from 'react'
import Icon from './Icon'
import Popover from './tooltip/popover'
import { MODEL_OPTIONS, getQualityOptions, getRatioOptions } from './constants'

export default function DrawerFooter({
  model, ratio, quality,
  onModelChange, onRatioChange, onQualityChange,
  canGenerate, loading, onGenerate, count,
}) {
  const [modelPopoverOpen, setModelPopoverOpen] = useState(false)
  const [paramsPopoverOpen, setParamsPopoverOpen] = useState(false)
  const qualityOptions = getQualityOptions(model)
  const ratioOptions = getRatioOptions(model, quality)

  const modelPopoverContent = (
    <div className="fdai-model-popover">
      {MODEL_OPTIONS.map(opt => (
        <button key={opt.value} className={`fdai-model-option ${model === opt.value ? 'active' : ''}`} onClick={() => onModelChange(opt.value)}>
          <img className="fdai-model-option-icon" src={opt.icon} alt="" />
          <span className="fdai-model-option-content">
            <span className="fdai-model-option-topline">
              <span className="fdai-model-option-label">{opt.label}</span>
              {opt.tag && <span className="fdai-model-option-tag">{opt.tag}</span>}
            </span>
            <span className="fdai-model-option-desc">{opt.description}</span>
          </span>
          {model === opt.value && <Icon type="zykj-gouxuan" className="fdai-model-option-check" />}
        </button>
      ))}
    </div>
  )

  const paramsPopoverContent = (
    <div className="fdai-params-popover">
      <div className="fdai-popover-section">
        <div className="fdai-popover-label">生图比例</div>
        <div className="fdai-ratio-options fdai-ratio-options-grid">
          {ratioOptions.map(opt => (
            <button key={opt.value} className={`fdai-ratio-btn ${ratio === opt.value ? 'active' : ''}`} onClick={() => onRatioChange(opt.value)}>
              {opt.value === 'auto' ? (
                <Icon type="icon-zidong" className="fdai-ratio-icon" />
              ) : (
                <span className="fdai-ratio-shape" style={opt.icon} />
              )}
              <span>{opt.label}</span>
            </button>
          ))}
        </div>
      </div>
      <div className="fdai-popover-section">
        <div className="fdai-popover-label">分辨率</div>
        <div className="fdai-ratio-options fdai-quality-options">
          {qualityOptions.map(opt => (
            <button key={opt.value} className={`fdai-ratio-btn ${quality === opt.value ? 'active' : ''}`} onClick={() => onQualityChange(opt.value)}>
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  )

  return (
    <div className="fdai-drawer-footer">
      <Popover content={modelPopoverContent} placement="top" trigger="click" overlayClassName="fdai-settings-popover" open={modelPopoverOpen} onOpenChange={setModelPopoverOpen} zIndex={10000}>
        <button className="fdai-settings-btn">
          <span>{MODEL_OPTIONS.find(m => m.value === model)?.label || '选择模型'}</span>
          <Icon type="zykj-xiala" />
        </button>
      </Popover>
      <Popover content={paramsPopoverContent} placement="top" trigger="click" overlayClassName="fdai-settings-popover" open={paramsPopoverOpen} onOpenChange={setParamsPopoverOpen} zIndex={10000}>
        <button className="fdai-settings-btn">
          <Icon type="icon-shaixuan" />
          <span>{ratio}</span>
          <span className="fdai-settings-divider" />
          <span>{quality.toUpperCase()}</span>
          <Icon type="zykj-xiala" />
        </button>
      </Popover>
      <button className="generate-btn" disabled={!canGenerate} onClick={onGenerate}>
        <span className="generate-btn-text">{loading ? '生成中...' : '生成图片'}</span>
        <span className="generate-btn-count">
          <Icon type="zycishu" className="generate-btn-count-icon" />
          <span>{count ?? '--'}</span>
        </span>
      </button>
    </div>
  )
}
